/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { JoinEntityDto } from './join-entity-dto';
 /**
 *
 *
 * @export
 * @interface CreateExerciseSourceDto
 */
export interface CreateExerciseSourceDto {

    /**
     * Object name for the resource. Optional when an uploadId is given, in which case it is derived from the uploaded content (content-addressed). Cannot be changed on an existing source unless new bytes come with it.
     *
     * @type {string}
     * @memberof CreateExerciseSourceDto
     */
    name?: string;

    /**
     * uploadId returned by POST /files/uploads
     *
     * @type {string}
     * @memberof CreateExerciseSourceDto
     */
    uploadId?: string;

    /**
     * uploadId of the bundle manifest; required for BUNDLE sources
     *
     * @type {string}
     * @memberof CreateExerciseSourceDto
     */
    manifestUploadId?: string;

    /**
     * @type {string}
     * @memberof CreateExerciseSourceDto
     */
    os: CreateExerciseSourceDtoOsEnum;

    /**
     * @type {string}
     * @memberof CreateExerciseSourceDto
     */
    type: CreateExerciseSourceDtoTypeEnum;

    /**
     * @type {JoinEntityDto}
     * @memberof CreateExerciseSourceDto
     */
    exercise?: JoinEntityDto;

    /**
     * @type {JoinEntityDto}
     * @memberof CreateExerciseSourceDto
     */
    client?: JoinEntityDto;
}

/**
 * @export
 * @enum {string}
 */
export enum CreateExerciseSourceDtoOsEnum {
    IOS = 'IOS',
    ANDROID = 'ANDROID',
    WEB = 'WEB',
    MACOS = 'MACOS',
    LINUX = 'LINUX',
    WINDOWS = 'WINDOWS',
    ALL = 'ALL'
}
/**
 * @export
 * @enum {string}
 */
export enum CreateExerciseSourceDtoTypeEnum {
    BUNDLE = 'BUNDLE',
    THUMBNAIL = 'THUMBNAIL',
    ICON = 'ICON',
    COVER = 'COVER',
    VIDEO = 'VIDEO'
}

